import {FileToDownload} from './file-to-download';
import {PostSynchroActions} from './PostSynchro/postSynchroActions';
import {ImportRequirement} from './import-requirement';
import {JsonObject, JsonProperty} from 'json2typescript';
import {Clone} from './cloning/clone';

@JsonObject('Terminal')
export class Terminal {

    @JsonProperty('id',Number)
    id = 0;

    @JsonProperty('name',String)
    name='';

    @JsonProperty('type',String)
    type='';

    // main_file TODO:must be renamed.
    @JsonProperty('main_file',String,true)
    src='';

    @JsonProperty('associatedQuestionnaireId',Number)
    associatedQuestionnaireId = 0; // associated questionnaireProject

    @JsonProperty('username',String)
    username='';

    @JsonProperty('password',String)
    password='';

    @JsonProperty('filesToDownload',[FileToDownload])
    filesToDownload:FileToDownload[] = [];

    @JsonProperty('languages',[String])
    languages:string[] = [];

    @JsonProperty('actionPostSynchro')
    actionPostSynchro:PostSynchroActions[] = [];

    @JsonProperty('clone',Clone,true)
    clone:Clone = new Clone();

    @JsonProperty('isSelected',Boolean,true)
    isSelected=false; // this boolean also present in Project class as well as questionnaire class is only used by the file chooser component // TODO: Try to create an common interface (eventually implemented by previously mentioned classes) to manipulate easily

    @JsonProperty('importRequirement',ImportRequirement,true)
    importRequirement:ImportRequirement = null;

    @JsonProperty('createdDate',String)
    createdDate = '';

    @JsonProperty('lastModifiedDate',String)
    lastModifiedDate = '';

    @JsonProperty('tags',[String],true)
    tags:string[] = [];

    @JsonProperty('isGallery',Boolean,true)
    isGallery = false;

    @JsonProperty('dataSrcTId',Number,true)
    dataSrcTId = 0;

    @JsonProperty('selectedEmailTemplate',String,true)
    selectedEmailTemplate = '';

    @JsonProperty('selectedSmsTemplate',String,true)
    selectedSmsTemplate = '';

    @JsonProperty('selectedMicrosite',String,true)
    selectedMicrosite = '';

    constructor() {
      /*this.id = json.id;
      this.name = json.name;
      this.type = json.type;
      this.src = json.src;
      this.associatedQuestionnaireId = json.associatedQuestionnaireId;
      this.username = json.username;
      this.password = json.password;
      this.createdDate = json.createdDate;
      this.lastModifiedDate = json.lastModifiedDate;

      this.filesToDownload = new Array<FileToDownload>();
      if(json.filesToDownload!=null) {
        let fic;
        for (let i = 0; i < json.filesToDownload.length; i++) {
          fic =new FileToDownload(json.filesToDownload[i]);
          fic.associatedTerminalName = this.name;
          this.filesToDownload.push(fic);
        }
      }

      this.languages = new Array<string>();

      if(json.languages!=null) {
        for(let i =0; i< json.languages.length;i++) {
          this.languages.push(json.languages[i]);
        }
      }

      this.actionPostSynchro = new Array<PostSynchroActions>();
      if(json.actionPostSynchro!=null) {
        for(let i =0; i< json.actionPostSynchro.length;i++) {
          this.actionPostSynchro.push(json.actionPostSynchro[i]);
        }
      }

      if(json.clone != null) {
        console.log('clone not null');
        this.clone =new Clone(json.clone);
      }*/

    }


}
